<template>
  <ul class="form__field--checkbox">
    <li>
      <label :for="inputId">
        <input
          :id="inputId"
          :name="inputName"
          :checked="isChecked"
          true-value="yes"
          false-value="no"
          type="checkbox"
          @input="change"
        />
        <span>{{ label }}</span>
      </label>
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    label: { type: String, required: true },
    checked: { type: Boolean, required: false, default: () => false },
  },
  data() {
    return {
      isChecked: false,
    };
  },
  mounted() {
    this.isChecked = this.checked;
    this.$emit('input', this.isChecked);
  },
  computed: {
    inputName() {
      return `${this.label
        .toLowerCase()
        .replaceAll(' ', '-')
        .replaceAll('.', '')}`;
    },
    inputId() {
      return `forminput-${this.label.toLowerCase().replaceAll(' ', '-')}`;
    },
  },
  watch: {
    checked(val) {
      this.isChecked = val;
    },
  },
  methods: {
    change() {
      this.isChecked = !this.isChecked;
      this.$emit('input', this.isChecked);
    },
  },
};
</script>
<style scoped>
.form__field--checkbox label span::after {
  left: -2.35em;
}
.form__field--checkbox {
  margin-top: -0.7rem;
}
.form__field--checkbox label {
  font-size: 1.125rem;
}
</style>